import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface PreviewWarningDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  previousResponseCount: number;
}

export function PreviewWarningDialog({ 
  open, 
  onConfirm, 
  onCancel, 
  previousResponseCount 
}: PreviewWarningDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Preview Warning
          </AlertDialogTitle>
          <AlertDialogDescription className="text-left">
            You have {previousResponseCount > 1 ? `${previousResponseCount} previous responses` : 'a previous response'} for this test.
            {' '}
            <span className="font-medium text-foreground">
              Starting a new preview will replace your most recent response and score.
            </span>
            {' '}
            Are you sure you want to continue?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-amber-500 hover:bg-amber-600">
            Continue Preview
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}